import React from 'react';
import { useRoleModal } from '../contexts/RoleContext';
import { useNewCashRegister } from '../contexts/NewCashRegisterContext';
import NewCashRegisterModal from './cash-register/NewCashRegisterModal';
import '../styles/cash-register-modal.css';

const NewBusinessAppModals = () => {
  const { 
    showCashRegisterModal, 
    cashRegisterMode, 
    pendingCashRegisterAction, 
    handleCashRegisterAction,
    cancelCashRegisterModal
  } = useRoleModal();

  const {
    isModalOpen,
    modalMode,
    pendingAction,
    previousAmount,
    closeModal,
    handleModalConfirm
  } = useNewCashRegister();

  // Use new cash register modal if available, fallback to old one
  if (isModalOpen && pendingAction) {
    return (
      <NewCashRegisterModal
        isOpen={isModalOpen}
        onClose={closeModal}
        onConfirm={handleModalConfirm}
        mode={modalMode}
        previousAmount={previousAmount}
        workerName={pendingAction.workerName || 'Worker'}
        workerId={pendingAction.workerId || ''}
        sessionType={pendingAction.type}
      />
    );
  }

  // Fallback to RoleContext modal system
  if (!showCashRegisterModal || !pendingCashRegisterAction) return null;

  const handleClose = () => {
    cancelCashRegisterModal();
  };

  const resolvedPreviousAmount =
    pendingCashRegisterAction.previousAmount != null
      ? pendingCashRegisterAction.previousAmount
      : null;

  return (
    <NewCashRegisterModal
      isOpen={showCashRegisterModal}
      onClose={handleClose}
      onConfirm={handleCashRegisterAction}
      mode={cashRegisterMode}
      previousAmount={resolvedPreviousAmount}
      workerName={pendingCashRegisterAction.workerRole?.name || 'Worker'}
      workerId={pendingCashRegisterAction.workerRole?.id || ''}
      sessionType={pendingCashRegisterAction.type}
    />
  );
};

export default NewBusinessAppModals;
